/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

export default function Select(
  header: string,
  name: string,
  options: {
    disabled?: boolean,
    id: string,
    title: string
  }[],
  form: { [key: string]: string | undefined },
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void,
  disabled: boolean = false,
  isRequired: boolean = true) {
  // Resetting select to placeholder require value to be empty string
  const value = form[name];
  return (
    <div className={`${!!disabled ? 'disabled' : ''}`}>
      <FormGroup>
        <Label htmlFor={name} required={isRequired}>{header}{isRequired ? '*' : ''}</Label>
        <Input type='select' name={name} value={value} onChange={onChange} disabled={disabled} required={isRequired}>
          <option value={''} hidden>PLEASE SELECT</option>
          {options.map(o => <option disabled={o.disabled} key={`${name}_option_${o.id}`} value={o.id}>{o.title}</option>)}
        </Input>
      </FormGroup>
    </div>
  );
}
